module.exports = __webpack_public_path__ + "assets/notAllConfident.10339afa.svg";